// dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Scroll, { Element } from 'react-scroll';
import CircularProgress from 'material-ui/CircularProgress';
// redux
import { connect } from 'react-redux';
import componentBase from '../../../../src/lib/component-base';
import {
  clearPreviousQuote,
  createDataExportQuote,
  getDataExportById,
  getServerDate,
  handleFormSubmitValidation,
  resetAllFormFields,
  setSavedState,
  dismissLimitedDataExportSearch,
} from '../../redux/actions';
import {
  getDataExportsState,
  formatRequestData,
  convertStringDateToMoment,
} from '../../redux/selectors';
import pollForNewState from '../../../../shared/lib/poll-for-new-state';
// child components
import CompileDataForm from './children/CompileDataForm/CompileDataForm';
import ExportDataDescription from '../shared/ExportDataDescription/ExportDataDescription';
import MetadataChart from '../shared/MetadataChart/MetadataChart';
import DataExportsHeader from '../shared/DataExportsHeader';
import CustomLargeModal from './children/CustomLargeModal';
import LargeGenericModal from '../../../../shared/components/LargeGenericModal/LargeGenericModal';
// reference data
import industries from '../../../../shared/lib/industryOptions';
// icons
import headerIcon from '../../../../static/images/data-export-icons/DataExports-DataByX-Icons-WHITE.svg';
import tooManyDatasIcon from '../../../../static/images/data-export-icons/too-many-datas.svg';
import sprocketsIcon from '../../../../static/images/data-export-icons/Sprockets-Icon.svg';
import BannerAd from '../../../../shared/components/BannerAd/BannerAd';
import { DataExports as DataExportsAds } from '../ads';

// constants
const TIMEOUT = 90;
const SCROLL_OPTIONS = {
  duration: 900,
  delay: 0,
  smooth: true,
};
const SESSION_KEY = 'ExportsSearch';
const secondaryTextMap = {
  departing: 'By Departures',
  arriving: 'By Arrivals',
  route: 'By Route',
  deparr: 'By Departures or Arrivals',
};
@connect(state => ({
  airlines: state.DataExports.airlines,
  arrivalAirports: state.DataExports.arrivalAirports,
  departureAirports: state.DataExports.departureAirports,
  arrivalCountries: state.DataExports.arrivalCountries,
  arrivalCheckedSearchInvalid: state.DataExports.arrivalCheckedSearchInvalid,
  departureCountries: state.DataExports.departureCountries,
  arrivalCheckedSearch: state.DataExports.arrivalCheckedSearch,
  departureCheckedSearch: state.DataExports.departureCheckedSearch,
  dataExportQuoteCurrentEstimateoteError: state.DataExports.dataExportQuoteError,
  dataExportQuoteCurrentEstimateId: state.DataExports.dataExportQuoteCurrentEstimateId,
  dataExportQuoteCurrentEstimate: state.DataExports.dataExportQuoteCurrentEstimate,
  departureCheckedSearchInvalid: state.DataExports.departureCheckedSearchInvalid,
  overDataLimit: state.DataExports.overDataLimit,
  exportTypeTitles: state.DataExports.exportTypeTitles,
  includeCargo: state.DataExports.exportFormincludeCargo,
  includeCodeshares: state.DataExports.exportFormIncludeCodeshares,
  inputObjectDefaults: state.DataExports.inputObjectDefaults,
  arrivalRegions: state.DataExports.arrivalRegions,
  departureRegions: state.DataExports.departureRegions,
  selectedStartDate: convertStringDateToMoment(state.DataExports.exportFormStartDate),
  selectedStartDateInvalid: state.DataExports.exportFormStartDateInvalid,
  selectedEndDate: convertStringDateToMoment(state.DataExports.exportFormEndDate),
  selectedEndDateInvalid: state.DataExports.exportFormEndDateInvalid,
  serverDate: convertStringDateToMoment(state.DataExports.serverDate),
  underDataMinimum: state.DataExports.underDataMinimum,
  user: state.Account.user,
  userIndustrySelect: state.DataExports.userExportIndustrySelect,
  userIndustrySelectInvalid: state.DataExports.userExportIndustrySelectInvalid,
  userExportIntendedUse: state.DataExports.userExportIntendedUse,
  userExportIntendedUseInvalid: state.DataExports.userExportIntendedUseInvalid,
}))
@componentBase('ExportsSearch')
export default class ExportsSearch extends Component {
  static propTypes = {
    airlines: PropTypes.array,
    arrivalAirports: PropTypes.array,
    arrivalCountries: PropTypes.array,
    departureCountries: PropTypes.array,
    departureAirports: PropTypes.array,
    arrivalRegions: PropTypes.array,
    departureRegions: PropTypes.array,
    category: PropTypes.string,
    arrivalCheckedSearch: PropTypes.string,
    arrivalCheckedSearchInvalid: PropTypes.string,
    departureCheckedSearch: PropTypes.string,
    departureCheckedSearchInvalid: PropTypes.string,
    dispatch: PropTypes.func,
    dataExportQuoteCurrentEstimate: PropTypes.object,
    dataExportQuoteCurrentEstimateId: PropTypes.number,
    dataExportQuoteError: PropTypes.object,
    exportTypeTitles: PropTypes.object,
    history: PropTypes.object,
    includeCargo: PropTypes.bool,
    includeCodeshares: PropTypes.bool,
    inputObjectDefaults: PropTypes.object,
    overDataLimit: PropTypes.bool,
    match: PropTypes.object,
    name: PropTypes.string,
    selectedStartDate: PropTypes.object,
    selectedStartDateInvalid: PropTypes.string,
    selectedEndDate: PropTypes.object,
    selectedEndDateInvalid: PropTypes.string,
    serverDate: PropTypes.object,
    underDataMinimum: PropTypes.bool,
    userExportIntendedUse: PropTypes.string,
    userExportIntendedUseInvalid: PropTypes.string,
    userIndustrySelect: PropTypes.string,
    userIndustrySelectInvalid: PropTypes.string,
    user: PropTypes.object,
  }

  state = {
    overLimitModalOpen: this.props.overDataLimit || false,
    underMinimumModalOpen: this.props.underDataMinimum || false,
    generatingQuoteModalOpen: false,
    totalTimeout: TIMEOUT,
  }

  componentWillMount() {
    this.pollForFinalQuoteData = this.pollForFinalQuoteData.bind(this);
    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleModalAction = this.handleModalAction.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;

    const frozen = this.frozenState(this.context.store);

    if (frozen) {
      const newState = {
        ...frozen,
        ...{
          dataExportQuoteCurrentEstimate: null,
          dataExportQuoteCurrentEstimateId: null,
          overDataLimit: null,
          underDataMinimum: null,
        },
      };
      dispatch(setSavedState(newState));
      this.handleClearFrozenState();
    }
    dispatch(getServerDate());
  }

  componentWillReceiveProps(nextProps) {
    const {
      dataExportQuoteError,
    } = nextProps;

    if (dataExportQuoteError) {
      this.context.toast.error(dataExportQuoteError.text, 'Error', true);
    }
  }

  componentWillUnmount() {
    this.handlePageUnload();
  }

  onSubmit = () => {
    const {
      dispatch,
      match,
    } = this.props;
    const {
      exportType,
    } = match && match.params;

    // validate the inputs, error messaging is implicit in the validation actions
    const globalState = this.context.store.getState();
    const action = dispatch(handleFormSubmitValidation(globalState, exportType));
    const { invalidForm, invalidValues } = action && action.result;
    if (!invalidForm) {
      // It's valid let's go!
      this.clearPreviousQuote();
      this.setState({
        generatingQuoteModalOpen: true,
      });
      const requestData = formatRequestData(globalState, exportType);
      // this.logger('requestData', requestData);
      const data = { ...requestData, pollForFinalQuoteData: this.pollForFinalQuoteData };
      dispatch(createDataExportQuote(data));
    } else {
      // scroll to errors if necessary
      let error = invalidValues.shift();
      let domError;
      while (domError || invalidValues.length) {
        try {
          domError = document.getElementById(error);
          if (domError) break;
        } catch (e) {
          // couldnt find?
        }
        error = invalidValues.shift();
      }
      Scroll.scroller.scrollTo(error, SCROLL_OPTIONS);
    }
  }


  setTimerRef = (newTimer) => {
    this.timer = newTimer();
  }

  killTimer = () => {
    clearTimeout(this.timer);
    this.timer = null;
    this.setState({
      totalTimeout: TIMEOUT,
      generatingQuoteModalOpen: false,
    });
  }

  clearPreviousQuote = () => {
    this.handleClearFrozenState();
    const { dataExportQuoteCurrentEstimate } = this.props;
    if (dataExportQuoteCurrentEstimate) {
      const { status } = dataExportQuoteCurrentEstimate;
      if (status && status === 'count_succeeded') {
        this.props.dispatch(clearPreviousQuote());
      }
    }
  }

  scrollToSuccessData = () => {
    Scroll.scroller.scrollTo('scroll-to-quote-data-success', SCROLL_OPTIONS);
  }

  scrollToTop = () => {
    Scroll.animateScroll.scrollToTop();
  }

  formReset = () => {
    this.handleClearFrozenState();
    this.setState({
      overLimitModalOpen: false,
      underMinimumModalOpen: false,
      totalTimeout: TIMEOUT,
    });
    const { dispatch } = this.props;
    dispatch(resetAllFormFields());
  }

  handlePageUnload = () => {
    this.scrollToTop();
    this.killTimer();
    const {
      overDataLimit,
      underDataMinimum,
    } = this.props;
    if (overDataLimit || underDataMinimum) {
      this.props.dispatch(clearPreviousQuote());
    }
  }

  handleDismissLimitedQuote = () => {
    const {
      overDataLimit,
      underDataMinimum,
      dataExportQuoteCurrentEstimate,
    } = this.props;
    if (dataExportQuoteCurrentEstimate) {
      const {
        dismissed,
      } = dataExportQuoteCurrentEstimate;
      if ((overDataLimit || underDataMinimum) && !dismissed) {
        this.props.dispatch(dismissLimitedDataExportSearch(dataExportQuoteCurrentEstimate));
      }
    }
  }

  handleModalToggle = ({ elementName }) => {
    // TODO: report click to ga
    this.killTimer();
    this.props.dispatch(clearPreviousQuote());
    this.handleDismissLimitedQuote();

    this.setState({
      [elementName]: false,
    });
  }

  handleModalAction = ({ elementName }) => {
    // TODO: report click to ga
    this.handleDismissLimitedQuote();
    this.setState({
      [elementName]: false,
    });
    if (elementName === 'overLimitModalOpen') {
      this.handleFreezeState();
    }
  }

  handleFreezeState = () => {
    const { store } = this.context;
    const globalState = store.getState();
    const currentState = getDataExportsState(globalState);
    this.freezeState(store, currentState, SESSION_KEY);
  }

  handleClearFrozenState = () => {
    const { store } = this.context;
    this.freezeState(store, null);
    this.props.dispatch(setSavedState({}));
  }

  handleSetTimeout = () => {
    this.setState({
      totalTimeout: this.state.totalTimeout - 1.5,
    });
    return false;
  }

  handleTimeoutReached = () => {
    if (this.state.totalTimeout < 1) {
      this.context.toast.warning('Timed Out: Please Modify Your Quote or Try Again', 'Timed Out', true);
      return true;
    }
    return false;
  }

  handlePollingIdMismatch = (data) => {
    const {
      id,
      oldId,
    } = data;
    if (id !== oldId) {
      const ex = new Error(`hub callback returned an unexpected id polling for data exports expected: ${oldId} got ${id}`);
      this.exception(ex, 'Data Exports ExportsSearch Container');
      return true;
    }
    return false;
  }

  handleNewStatus = (data) => {
    const {
      dismissed,
      status,
    } = data;
    switch (status) {
      case 'count_failed':
        this.context.toast.error('We are temporarily unable to quote your export. Please try again in a few minutes.', 'Error', true);
        return true;
      case 'over-data-limit':
        if (!dismissed) {
          this.setState({
            overLimitModalOpen: true,
          });
        }
        return true;
      case 'under-data-minimum':
        if (!dismissed) {
          this.setState({
            underMinimumModalOpen: true,
          });
        }
        return true;
      case 'count_succeeded':
        this.context.toast.success('Your Quote is Ready!', 'Success', false, 5);
        this.scrollToSuccessData();
        return true;
      default:
        return false;
    }
  }

  pollForFinalQuoteData = (currentEstimateId) => {
    const exitCallbacks = [
      this.handleSetTimeout,
      this.handleTimeoutReached,
      data => this.handlePollingIdMismatch({ ...data, oldId: currentEstimateId }),
      this.handleNewStatus];
    const pollingArgs = {
      initialPromise: () => this.props.dispatch(getDataExportById(currentEstimateId)),
      killTimer: this.killTimer,
      exitCallbacks,
      interval: 1500,
      setTimerRef: this.setTimerRef,
      displayName: 'ExportsSearch',
    };
    pollForNewState(pollingArgs);
  }

  exportType = () => {
    let secondaryText = 'Historical Flight Status';
    const { match } = this.props;
    if (match && match.params && match.params.exportType) {
      const { exportType } = match.params;
      secondaryText = `${secondaryText} ${secondaryTextMap[exportType]}`;
    }
    return secondaryText;
  }

  exportCategory = () => {
    if (this.props && this.props.category) {
      return this.props.category;
    }
    return '';
  }

  quoteData = () => {
    let data = { metaData: { } };

    if (this.props.overDataLimit ||
        this.props.underDataMinimum) {
      return data;
    }

    const { dataExportQuoteCurrentEstimate } = this.props;

    if (!dataExportQuoteCurrentEstimate) {
      return data;
    }

    const { status } = dataExportQuoteCurrentEstimate;

    if (status && status === 'count_succeeded') {
      data = dataExportQuoteCurrentEstimate;
    }
    return data;
  }

  hasQuoteLoaded = () => {
    if (this.props) {
      const {
        dataExportQuoteCurrentEstimate,
        overDataLimit,
        underDataMinimum,
      } = this.props;
      if (!overDataLimit && !underDataMinimum && dataExportQuoteCurrentEstimate) {
        const { status } = dataExportQuoteCurrentEstimate;
        if (status && status === 'count_succeeded') {
          return true;
        }
      }
    }
    return false;
  }


  selectedStartDate = () => this.props && moment.utc(this.props.selectedStartDate);

  selectedEndDate = () => this.props && moment.utc(this.props.selectedEndDate);

  userExportIntendedUse = () => (this.props && this.props.userExportIntendedUse) || '';

  userIndustrySelect = () => this.props && this.props.userIndustrySelect;

  includeCodeshares = () => this.props && !!this.props.includeCodeshares;

  includeCargo = () => this.props && !!this.props.includeCargo;

  timer = null;

  renderGeneratingQuoteModalBody = () => {
    const spinnerStyle = {
      display: 'block',
      width: '50px',
      height: '50px',
      margin: '25px auto',
    };
    return (
      <div>
        <p style={{ color: 'black' }}>Please wait while we generate your data export quote.</p>
        <CircularProgress mode='indeterminate' color='#FAA718' style={spinnerStyle} />
      </div>
    );
  }

  renderOverLimitModalOpenBody = () => {
    const { dataExportQuoteCurrentEstimate } = this.props;
    let firstPartOfMessage = 'Your export exceeds 100,000 rows which is the maximum number of rows this export tool supports.';

    if (dataExportQuoteCurrentEstimate && dataExportQuoteCurrentEstimate.count) {
      firstPartOfMessage = `Your export includes ${dataExportQuoteCurrentEstimate.count.toLocaleString()} rows. This exceeds 100,000 which is the maximum number of rows this export tool supports.`;
    }

    return (
      <div style={{ width: '90%', margin: '0 auto 15px' }}>
        <p style={{ color: 'black', fontSize: '12pt', lineHeight: '12pt' }} >{firstPartOfMessage} Please constrain your request, or contact a representative to get a price quote on your large export.</p>
      </div>
    );
  }

  render() {
    const {
      airlines,
      arrivalAirports,
      arrivalCheckedSearch,
      arrivalCheckedSearchInvalid,
      arrivalCountries,
      arrivalRegions,
      departureAirports,
      departureCheckedSearch,
      departureCheckedSearchInvalid,
      departureCountries,
      departureRegions,
      dispatch,
      match,
      user,
    } = this.props;
    const { subscriptionActive } = user;
    const adUnits = {
      mobileAd: DataExportsAds.topMobile,
      desktopAd: DataExportsAds.top,
    };

    return (
      <div className='data-exports-search-container'>
        <BannerAd
          topAd
          {...adUnits}
          subscriptionActive={subscriptionActive}
          style={{ marginBottom: '-10px' }}
        />
        <DataExportsHeader
          primaryText={`${this.exportCategory()} Data Export`}
          secondaryText={this.exportType()}
        />
        <CompileDataForm
          airlines={airlines}
          arrivalAirports={arrivalAirports}
          departureAirports={departureAirports}
          arrivalCheckedSearch={arrivalCheckedSearch}
          arrivalCheckedSearchInvalid={arrivalCheckedSearchInvalid}
          departureCheckedSearchInvalid={departureCheckedSearchInvalid}
          departureCheckedSearch={departureCheckedSearch}
          arrivalCountries={arrivalCountries}
          departureCountries={departureCountries}
          dispatch={dispatch}
          headerIcon={headerIcon}
          formReset={this.formReset}
          includeCodeshares={this.includeCodeshares()}
          includeCargo={this.includeCargo()}
          inputObjectDefaults={this.props.inputObjectDefaults}
          industries={industries}
          onSubmit={this.onSubmit}
          params={match && match.params}
          arrivalRegions={arrivalRegions}
          departureRegions={departureRegions}
          selectedStartDate={this.selectedStartDate() || null}
          selectedEndDate={this.selectedEndDate() || null}
          userIndustrySelect={this.userIndustrySelect() || null}
          userExportIntendedUse={this.userExportIntendedUse() || ''}
          selectedStartDateInvalid={this.props.selectedStartDateInvalid}
          selectedEndDateInvalid={this.props.selectedEndDateInvalid}
          serverDate={this.props.serverDate}
          user={this.props.user}
          userIndustrySelectInvalid={this.props.userIndustrySelectInvalid}
          userExportIntendedUseInvalid={this.props.userExportIntendedUseInvalid}
        />
        <CustomLargeModal
          modalOpen={this.state.overLimitModalOpen}
          closeModal={() => this.handleModalToggle({ elementName: 'overLimitModalOpen' })}
          title='Your Export Exceeds the Maximum Number of Rows'
          image={tooManyDatasIcon}
          actionTitle='CONTACT A REPRESENTATIVE'
          disableButtons={false}
          selectAction={() => this.handleModalAction({ elementName: 'overLimitModalOpen' })}
          body={this.renderOverLimitModalOpenBody()}
          secondaryActionTitle='Cancel'
          secondaryActionStyle={{ color: 'black', textDecoration: 'underline' }}
          secondaryActionBackgroundColor='transparent'
          secondaryActionHoverColor='rgb(129, 162, 202)'
        />
        <LargeGenericModal
          isModal
          modalOpen={this.state.generatingQuoteModalOpen}
          disableButtons={false}
          title='Generating Quote'
          image={sprocketsIcon}
          body={this.renderGeneratingQuoteModalBody()}
          noSecondaryButton
          noPrimaryButton
        />
        <LargeGenericModal
          modalOpen={this.state.underMinimumModalOpen}
          closeModal={() => this.handleModalToggle({ elementName: 'underMinimumModalOpen' })}
          selectAction={() => this.handleModalAction({ elementName: 'underMinimumModalOpen' })}
          title='No Flights Were Found'
          image={tooManyDatasIcon}
          actionTitle='Search Again'
          disableButtons={false}
          body={(<div />)}
          noSecondaryButton
        />
        <Element name='scroll-to-quote-data-success' />
        {this.hasQuoteLoaded() ? <ExportDataDescription dispatch={this.props.dispatch} quoteData={this.quoteData()} /> : <div className='no-quote-bottom' />}
        {this.hasQuoteLoaded() ? <MetadataChart quoteData={this.quoteData()} /> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/DataExports/components/ExportsSearch/ExportsSearchContainer.js